var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeastar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 401 390",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "s",
    xlinkHref: "#v",
    patternTransform: "translate(144.12 548.07)"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    width: 28.57143,
    height: 27.85712,
    patternTransform: "translate(67.857 529.15)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.857 -529.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76.429 533.43c0 1.7752-1.2792 3.2143-2.8571 3.2143-1.578 0-2.8571-1.4391-2.8571-3.2143s1.2792-3.2143 2.8571-3.2143c1.578 0 2.8571 1.4391 2.8571 3.2143z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.286 543.79c0 1.9724-1.2792 3.5714-2.8571 3.5714-1.578 0-2.8571-1.599-2.8571-3.5714s1.2792-3.5714 2.8571-3.5714c1.578 0 2.8571 1.599 2.8571 3.5714z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.857 535.22c0 1.9724-1.2792 3.5714-2.8571 3.5714-1.578 0-2.8571-1.599-2.8571-3.5714s1.2792-3.5714 2.8571-3.5714c1.578 0 2.8571 1.599 2.8571 3.5714z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.357 550.76c0 1.8738-1.4391 3.3928-3.2143 3.3928s-3.2143-1.519-3.2143-3.3928 1.4391-3.3929 3.2143-3.3929 3.2143 1.519 3.2143 3.3929z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.429 549.51c0 1.7752-1.0393 3.2143-2.3214 3.2143s-2.3214-1.4391-2.3214-3.2143 1.0393-3.2143 2.3214-3.2143 2.3214 1.4391 2.3214 3.2143z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.643 531.83c0 1.4793-0.87944 2.6786-1.9643 2.6786-1.0848 0-1.9643-1.1992-1.9643-2.6786 0-1.4793 0.87944-2.6786 1.9643-2.6786 1.0848 0 1.9643 1.1992 1.9643 2.6786z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.786 554.68c0 1.2821-1.1193 2.3214-2.5 2.3214s-2.5-1.0393-2.5-2.3214 1.1193-2.3214 2.5-2.3214 2.5 1.0393 2.5 2.3214z",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.143 540.58c0 1.3807-0.95939 2.5-2.1429 2.5s-2.1429-1.1193-2.1429-2.5 0.95939-2.5 2.1429-2.5 2.1429 1.1193 2.1429 2.5z",
    fill: "#d35f5f"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -0.00132,
    x2: 1.0013,
    y1: 0.49998,
    y2: 0.49998
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d20b02",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d24c2f",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba2929",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75724
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: -0.04797,
    y: -0.13497,
    width: 1.0959,
    height: 1.2699,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75724
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: -0.16832,
    y: -0.04461,
    width: 1.3366,
    height: 1.0892,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75724
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75724
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    x: -0.03883,
    y: -0.13189,
    width: 1.0777,
    height: 1.2638,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.92405
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 449.64,
    cy: 269.15,
    r: 29.643,
    gradientTransform: "matrix(.57147 -.60563 1.7208 1.6237 -276.17 103.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a00",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: -0.23494,
    y: -0.3,
    width: 1.4699,
    height: 1.6,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.80357
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5799
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 225.49,
    cy: 345.81,
    r: 38.553,
    gradientTransform: "translate(75.528 18.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    label: "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.607 -23.359) matrix(1.0046 0 0 1.0046 -220.26 -74.807)",
    fill: "#2b0000",
    filter: "url(#u)",
    label: "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m326.95 105.94c-1.6854 11.77 43.437 78.118 61.619 131.32-6.1919-8.2559-149.63 56.994-136.37 90.914 6.9702 17.837 142.37-12.762 168.7-30.305-14.957 15.695-6.7144 154.09 3.0304 167.69 14.335 19.995 88.863-122.15 41.416-175.77 41.677 54.773 169.4 42.529 168.7 20.203-0.50013-15.794-137.38-62.629-137.38-62.629s93.845-123.67 78.792-130.31c-43.07-18.975-132.64 75.33-135.38 92.95-30.33-95.52-112.45-108.83-113.13-104.05l0.0026-0.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.78 105.58c-1.6854 11.77 43.437 78.118 61.619 131.32-6.1919-8.2559-149.63 56.994-136.37 90.914 6.9702 17.837 142.37-12.762 168.7-30.305-14.957 15.695-6.7144 154.09 3.0304 167.69 14.335 19.995 88.863-122.15 41.416-175.77 41.677 54.773 169.4 42.529 168.7 20.203-0.50013-15.794-137.38-62.629-137.38-62.629s93.845-123.67 78.792-130.31c-43.07-18.976-132.64 75.33-135.38 92.95-30.33-95.52-112.45-108.83-113.13-104.05l0.0026-0.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.43 327.36c9.2857-7.1428 187.86-65 187.86-65 6.8832-0.46928 20.332 22.581-8.5714 34.286-53.249 21.875-130.56 37.613-179.29 30.714h0.0014z",
    filter: "url(#p)",
    opacity: 0.39726
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.71 118.08c-89.045 52.296-96.648 96.835-137.86 145.71-10.492 15.93 56.93 28.751 137.86-145.71z",
    filter: "url(#o)",
    opacity: 0.41096
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 890 -10.714)",
    d: "m440 263.08c-4.7519 46.946-5.6768 155.75 22.143 216.43 19.212-3.8889 11.798-154.03 6.4286-170.71l-28.572-45.72z",
    filter: "url(#n)",
    opacity: 0.30479
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.86 106.65c67.75 48.96 113.5 112.25 120.71 165-22.48-9.42-72.81-3.86-58.57-37.14l-62.14-127.86z",
    filter: "url(#m)",
    opacity: 0.23973
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635 312.36l-190-46.43 24.29 25.72c47.77 43.8 132.69 43.96 165.71 20.71z",
    filter: "url(#r)",
    opacity: 0.37329
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.58 267.72c0 12.821-13.272 23.214-29.643 23.214s-29.643-10.393-29.643-23.214 13.272-23.214 29.643-23.214 29.643 10.393 29.643 23.214z",
    filter: "url(#q)",
    opacity: 0.27055
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m326.95 105.94c-1.6854 11.77 43.437 78.118 61.619 131.32-6.1919-8.2559-149.63 56.994-136.37 90.914 6.9702 17.837 142.37-12.762 168.7-30.305-14.957 15.695-6.7144 154.09 3.0304 167.69 14.335 19.995 88.863-122.15 41.416-175.77 41.677 54.773 169.4 42.529 168.7 20.203-0.50013-15.794-137.38-62.629-137.38-62.629s93.845-123.67 78.792-130.31c-43.07-18.975-132.64 75.33-135.38 92.95-30.33-95.52-112.45-108.83-113.13-104.05l0.0026-0.013z",
    fill: "url(#t)",
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m326.78 105.58c-1.6854 11.77 43.437 78.118 61.619 131.32-6.1919-8.2559-149.63 56.994-136.37 90.914 6.9702 17.837 142.37-12.762 168.7-30.305-14.957 15.695-6.7144 154.09 3.0304 167.69 14.335 19.995 88.863-122.15 41.416-175.77 41.677 54.773 169.4 42.529 168.7 20.203-0.50013-15.794-137.38-62.629-137.38-62.629s93.845-123.67 78.792-130.31c-43.07-18.976-132.64 75.33-135.38 92.95-30.33-95.52-112.45-108.83-113.13-104.05l0.0026-0.013z",
    fill: "url(#s)",
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m251.43 327.36c9.2857-7.1428 187.86-65 187.86-65 6.8832-0.46928 20.332 22.581-8.5714 34.286-53.249 21.875-130.56 37.613-179.29 30.714h0.0014z",
    fill: "#800000",
    filter: "url(#p)",
    opacity: 0.39726,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m575.71 118.08c-89.045 52.296-96.648 96.835-137.86 145.71-10.492 15.93 56.93 28.751 137.86-145.71z",
    fill: "#800000",
    filter: "url(#o)",
    opacity: 0.41096,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 656.22 -107.5)",
    d: "m440 263.08c-4.7519 46.946-5.6768 155.75 22.143 216.43 19.212-3.8889 11.798-154.03 6.4286-170.71l-28.572-45.72z",
    fill: "#800000",
    filter: "url(#n)",
    opacity: 0.30479,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2) matrix(1 0 0 1 -233.78 -96.788)",
    d: "m327.86 106.65c67.75 48.96 113.5 112.25 120.71 165-22.48-9.42-72.81-3.86-58.57-37.14l-62.14-127.86z",
    fill: "#800000",
    filter: "url(#m)",
    opacity: 0.23973,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m635 312.36l-190-46.43 24.29 25.72c47.77 43.8 132.69 43.96 165.71 20.71z",
    fill: "#a00",
    filter: "url(#r)",
    opacity: 0.37329,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-233.78 -96.788)",
    d: "m473.58 267.72c0 12.821-13.272 23.214-29.643 23.214s-29.643-10.393-29.643-23.214 13.272-23.214 29.643-23.214 29.643 10.393 29.643 23.214z",
    fill: "url(#w)",
    filter: "url(#q)",
    opacity: 0.27055,
    label: "Calque 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.51209 0 0 .51209 83.148 -.24318)",
    d: "m240.9 363.85c0 19.718-15.985 35.703-35.703 35.703s-35.703-15.985-35.703-35.703 15.985-35.703 35.703-35.703 35.703 15.985 35.703 35.703z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.61497,
    strokeWidth: 5.7,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.51209 0 0 .51209 83.148 -.24318)",
    d: "m336.73 363.85c0 19.718-15.985 35.703-35.703 35.703s-35.703-15.985-35.703-35.703 15.985-35.703 35.703-35.703 35.703 15.985 35.703 35.703z",
    fill: "#fff",
    stroke: "url(#x)",
    strokeOpacity: 0.61497,
    strokeWidth: 5.7,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.51951 0 0 .51951 71.712 29.912)",
    d: "m244.29 306.54c0 6.7458-5.8051 12.214-12.966 12.214s-12.966-5.4685-12.966-12.214 5.805-12.214 12.966-12.214 12.966 5.4685 12.966 12.214z",
    opacity: 0.83857,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.51951 0 0 .51951 120.97 29.912)",
    d: "m244.29 306.54c0 6.7458-5.8051 12.214-12.966 12.214s-12.966-5.4685-12.966-12.214 5.805-12.214 12.966-12.214 12.966 5.4685 12.966 12.214z",
    opacity: 0.83857,
    label: "Capa 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeastar);
export default __webpack_public_path__ + "static/media/seastar.8ce751a2b7b9cde4213b5091e2f60c86.svg";
export { ForwardRef as ReactComponent };